<article class="workspace-page br-compact-page" [class.rd-inline]="inline"
         [class.workspace-page--full]="!inline" [class.workspace-page__panel--card]="!inline" *ngIf="hireId != null"
         aria-label="Roll-off deal detail">
  <header *ngIf="!inline" class="workspace-page__heading">
    <h1 class="workspace-page__title rd-title">{{ detail?.opportunity?.siteName || ('Deal #' + hireId) }}</h1>
    <div class="workspace-page__title-actions">
      <button type="button" class="br-btn-close" (click)="close()" aria-label="Close"></button>
    </div>
  </header>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <div class="rd-error" *ngIf="loadError"><br-icon>error_outline</br-icon> {{ loadError }}</div>

  <div class="rd-body" [class.workspace-page__body]="!inline" *ngIf="detail && !loadError">

    <section class="rd-section">
      <h3>Stage</h3>
      <!-- The stage badge is coloured by CODE and printed by NAME. The
           "finished" styling is decided by the OUTCOME: this vocabulary's
           winning stage is called Fulfillment, so nothing here recognises a
           word. -->
      <div class="rd-stage" [class.rd-finished]="finished">
        <span class="rd-stage-badge"
              [style.color]="stageColor(detail.opportunity.leadStageCode)">
          {{ stageLabel(detail.opportunity.leadStageCode, detail.opportunity.leadStageName) }}
        </span>
        <span class="rd-since">since {{ detail.opportunity.stageEnteredAt | date:'MMM d, y' }}</span>
      </div>
      <p class="rd-note" *ngIf="detail.opportunity.outcomeReason">
        {{ detail.opportunity.outcomeReason }}
      </p>
    </section>

    <section class="rd-section">
      <h3>The deal</h3>
      <dl class="rd-rows">
        <dt>Site</dt><dd>{{ detail.opportunity.siteName }}</dd>
        <dt>Address</dt><dd>{{ siteAddress(detail.opportunity) }}</dd>
        <!-- The catalog's wording, or — where the 2026-09-03 backfill could
             not place what a rep had typed — that phrase, marked as one. -->
        <dt>Container</dt>
        <dd>{{ containerLabel(detail.opportunity) || '—' }}
          <span class="rd-unplaced" *ngIf="isUnplacedSize(detail.opportunity)">
            recorded before there was a size list
          </span>
        </dd>
        <dt>Quoted</dt>
        <dd>{{ detail.opportunity.quotedPrice != null
              ? (detail.opportunity.quotedPrice | currency:'USD':'symbol':'1.0-2')
              : '—' }}</dd>
        <dt>Rental dates</dt><dd>{{ hireWindow(detail.opportunity) }}</dd>
        <dt>Sales rep</dt><dd>{{ ownerLabel(detail.opportunity) }}</dd>
      </dl>
      <div class="rd-actions" *ngIf="canManage">
        <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
                (click)="editHire()">
          <br-icon>edit</br-icon> Edit
        </button>
      </div>
    </section>

    <!-- The trail, newest first, as the server ordered it. -->
    <section class="rd-section">
      <h3>History</h3>
      <div class="rd-event" *ngFor="let entry of detail.history; trackBy: trackByEntry">
        <div class="rd-event-head">
          <span class="rd-event-stages">
            <span [style.color]="stageColor(entry.fromLeadStageCode)">{{
              stageLabel(entry.fromLeadStageCode, entry.fromLeadStageName) }}</span>
            →
            <strong [style.color]="stageColor(entry.toLeadStageCode)">{{
              stageLabel(entry.toLeadStageCode, entry.toLeadStageName) }}</strong>
          </span>
          <span class="rd-event-when">{{ entry.changedAt | date:'MMM d, y' }}</span>
        </div>
        <div class="rd-event-meta">{{ actorLabel(entry) }}</div>
        <div class="rd-event-note" *ngIf="entry.note">{{ entry.note }}</div>
      </div>
      <p class="rd-note" *ngIf="!detail.history.length">
        Nothing has moved yet — this deal is still where it was filed.
      </p>
    </section>

  </div>
</article>
